// extracted by css-extract-rspack-plugin
export default {"root":"QlmdA","input":"OjDbx"};